import { GhostButton, GridItem, Text } from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { css } from "@emotion/css";
import { useField } from "formik";
import React, { useContext, useState } from "react";
import { Trans } from "react-i18next";

import { AddressModal } from "./AddressModal";
import { AddressesList } from "./AddressesList";
import { ApplicationContext } from "../../Application.context";

type AddressesCheckField = components["schemas"]["AddressesCheckField"];

export function AddressInputField({
  field: config,
}: {
  field: AddressesCheckField;
}) {
  const { saveData } = useContext(ApplicationContext);
  const [field, , helpers] = useField<AddressesCheckField["value"]>(
    config.name
  );
  const { uncompleteSection } = useContext(ApplicationContext);
  const [addresses, setAddresses] = useState<
    components["schemas"]["AddressesCheckFieldValue"][]
  >(field.value);

  const handleSaveAddress = (
    newAddress: components["schemas"]["AddressesCheckFieldValue"],
    index: number
  ) => {
    const newAddresses = [...addresses];
    newAddresses[index] = newAddress;
    saveEntries(newAddresses);
    uncompleteSection("consent");
  };

  const handleDeleteAddress = (index: number) => {
    const newAddresses = [...addresses].filter((_, i) => index !== i);
    saveEntries(newAddresses);
  };

  const saveEntries = async (
    entries: components["schemas"]["AddressesCheckFieldValue"][]
  ) => {
    setAddresses(entries);
    await helpers.setValue(entries); // await required for race condition
    await saveData({ skipValidation: true, hasMultipleEntries: true });
  };

  const hasCurrentAddress = addresses.find(({ end_date }) => !end_date);

  return (
    <>
      <GridItem>
        <Text as="h2" style="form/section-heading">
          <Trans>My addresses</Trans>
        </Text>
      </GridItem>

      {addresses.length > 0 && (
        <AddressesList
          addresses={addresses}
          onSave={handleSaveAddress}
          onDelete={handleDeleteAddress}
        />
      )}

      <GridItem
        className={css({
          display: "block",
        })}
      >
        <AddressModal
          index={addresses.length}
          onSave={handleSaveAddress}
          allowCurrent={!hasCurrentAddress}
          trigger={
            <GhostButton
              testID="address-history-add-address-button"
              leftIcon="add"
              size="medium"
              fill="background-base"
              border="border-strong"
            >
              <Trans>Add address</Trans>
            </GhostButton>
          }
        />
      </GridItem>
    </>
  );
}
